export const categoryLabel = (cat) => {
  if (!cat) return "Uncategorized";
  // Capitalize first letter of each word for aesthetics
  return cat.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
};
